/* ==========================================================================
   HAPŪ HELPERS — LEGAL PAGE TOC BUILDER
   --------------------------------------------------------------------------
   Auto-builds the table-of-contents from H2 headings in the legal body.
   Mirrors the real-story TOC pattern.
   ========================================================================== */

(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 980;

  function init() {
    var body = document.querySelector('.hh-legal__body');
    var tocList = document.getElementById('hh-legal-toc-list');
    var tocDetails = document.getElementById('hh-legal-toc');
    if (!body || !tocList) return;

    var headings = body.querySelectorAll('h2');
    if (headings.length === 0) {
      var tocWrapper = document.querySelector('.hh-legal__toc');
      if (tocWrapper) tocWrapper.style.display = 'none';
      return;
    }

    function slugify(text) {
      return text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }

    var ids = [];
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent) || 'section';
        var id = base;
        var counter = 1;
        while (document.getElementById(id)) {
          id = base + '-' + (++counter);
        }
        h.id = id;
      }
      ids.push(h.id);

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.dataset.targetId = h.id;
      li.appendChild(a);
      tocList.appendChild(li);
    });

    var links = tocList.querySelectorAll('a');
    var activeSummary = document.querySelector('.hh-legal__toc-active');

    /* ===== Desktop/mobile open-state =================================== */

    function applyDesktopOpenState() {
      if (!tocDetails) return;
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        tocDetails.setAttribute('open', '');
      }
    }

    applyDesktopOpenState();
    window.addEventListener('resize', applyDesktopOpenState);


    /* ===== Click handling ============================================== */

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = this.dataset.targetId;
        var target = document.getElementById(targetId);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + targetId);

        if (tocDetails && window.innerWidth < DESKTOP_BREAKPOINT) {
          tocDetails.removeAttribute('open');
        }
      });
    });


    /* ===== Active heading observer ===================================== */

    var activeId = null;
    function setActive(id) {
      if (id === activeId) return;
      activeId = id;
      links.forEach(function (link) {
        if (link.dataset.targetId === id) {
          link.classList.add('is-active');
          if (activeSummary) activeSummary.textContent = link.textContent;
        } else {
          link.classList.remove('is-active');
        }
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries
        .filter(function (e) { return e.isIntersecting; })
        .map(function (e) { return e.target; });

      if (visible.length > 0) {
        visible.sort(function (a, b) {
          return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
        });
        setActive(visible[0].id);
      }
    }, {
      rootMargin: '-15% 0px -65% 0px',
      threshold: 0
    });

    headings.forEach(function (h) { observer.observe(h); });
    setActive(ids[0]);


    /* ===== Prevent desktop summary collapse ============================ */

    var summary = tocDetails && tocDetails.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (window.innerWidth >= DESKTOP_BREAKPOINT) {
          e.preventDefault();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
